/* eslint-disable custom-rules/modal-and-drawer-requires-title */
import { Drawer } from '@uhg-abyss/web/ui/Drawer';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { Text } from '@uhg-abyss/web/ui/Text';
import { t } from 'i18next';
import { find } from 'lodash';

import { useLagoon } from '../../hooks/useLagoon';
import { ConstantsLagoon } from '../ConstantsLagoon';
import { LinkWithTracking } from '../LinkWithTracking/LinkWithTracking';

export const WebsiteListDrawer = ({ isOpen, setIsOpen, websiteList }) => {
  const uiMessaging = useLagoon('ui-messaging')();
  const websiteDrawerText = find(uiMessaging, {
    key: ConstantsLagoon.UI_MESSAGING.WEBSITE_DRAWER_TEXT,
  })?.message;
  return (
    <Drawer
      data-testid="website-list-drawer"
      header={t('DETAILS_CHIP_NAMES.Websites')}
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
    >
      <Flex css={{ gap: '$sm' }} direction="column">
        <Text css={{ paddingBottom: '$sm' }}>{websiteDrawerText}</Text>
        {websiteList.map((site) => (
          <div key={`${site}-website`}>
            <LinkWithTracking
              analyticsInfo={{
                name: 'website',
                location: 'body:provider-website',
              }}
              css={{ wordBreak: 'break-word' }}
              data-auto-testid={`${site}-website`}
              data-testid={`${site}-website`}
              fontWeight="bold"
              href={site}
              openNewWindow={true}
            >
              {site}
            </LinkWithTracking>
          </div>
        ))}
      </Flex>
    </Drawer>
  );
};
